import { TPageConfig } from 'models/common.model'
import { THEMES } from 'root-constants'
import { PageIdWoofzVgs } from './pages-map'

export const ID_TO_PAGE_CONFIG_MAP_WOOFZ_VGS: Record<
  Exclude<PageIdWoofzVgs, PageIdWoofzVgs.ACCOUNT_NOVE8>,
  TPageConfig
> = {
  [PageIdWoofzVgs.DOG_AGE_VGS]: {
    id: PageIdWoofzVgs.DOG_AGE_VGS,
    theme: THEMES.VARIANT_VGS,
    hasHeader: true,
  },
  [PageIdWoofzVgs.SEX_VGS]: {
    id: PageIdWoofzVgs.SEX_VGS,
    theme: THEMES.VARIANT_VGS,
    hasHeaderBackButton: true,
    progressBar: 'controlled',
    hasHeader: true,
  },
  [PageIdWoofzVgs.DOG_BREED_VGS]: {
    id: PageIdWoofzVgs.DOG_BREED_VGS,
    theme: THEMES.VARIANT_VGS,
    hasHeaderBackButton: true,
    hasHeader: true,
    progressBar: 'controlled',
  },
  [PageIdWoofzVgs.URGE_VGS]: {
    id: PageIdWoofzVgs.URGE_VGS,
    theme: THEMES.URGE,
    progressBar: 'controlled',
    hasHeader: true,
  },
  [PageIdWoofzVgs.OTHER_DOGS_VGS]: {
    id: PageIdWoofzVgs.OTHER_DOGS_VGS,
    theme: THEMES.VARIANT_VGS,
    hasHeaderBackButton: true,
    progressBar: 'controlled',
    hasHeader: true,
  },
  [PageIdWoofzVgs.NOISES_VGS]: {
    id: PageIdWoofzVgs.NOISES_VGS,
    theme: THEMES.VARIANT_VGS,
    hasHeaderBackButton: true,
    progressBar: 'controlled',
    hasHeader: true,
  },
  [PageIdWoofzVgs.LEASH_PULLING_VGS]: {
    id: PageIdWoofzVgs.LEASH_PULLING_VGS,
    theme: THEMES.VARIANT_VGS,
    hasHeaderBackButton: true,
    progressBar: 'controlled',
    hasHeader: true,
  },
  [PageIdWoofzVgs.BARKS_VGS]: {
    id: PageIdWoofzVgs.BARKS_VGS,
    theme: THEMES.VARIANT_VGS,
    hasHeaderBackButton: true,
    progressBar: 'controlled',
    hasHeader: true,
  },
  [PageIdWoofzVgs.OUT_OF_CONTROL_VGS]: {
    id: PageIdWoofzVgs.OUT_OF_CONTROL_VGS,
    theme: THEMES.VARIANT_VGS,
    hasHeaderBackButton: true,
    progressBar: 'controlled',
    hasHeader: true,
  },
  [PageIdWoofzVgs.URGE_2_VGS]: {
    id: PageIdWoofzVgs.URGE_2_VGS,
    theme: THEMES.URGE,
    progressBar: 'controlled',
    hasHeader: true,
  },
  [PageIdWoofzVgs.BEHAVIOR_VGS]: {
    id: PageIdWoofzVgs.BEHAVIOR_VGS,
    theme: THEMES.VARIANT_VGS,
    hasHeaderBackButton: true,
    progressBar: 'controlled',
    hasHeader: true,
  },
  [PageIdWoofzVgs.TRIGGERS_VGS]: {
    id: PageIdWoofzVgs.TRIGGERS_VGS,
    theme: THEMES.VARIANT_VGS,
    hasHeaderBackButton: true,
    progressBar: 'controlled',
    hasHeader: true,
  },
  [PageIdWoofzVgs.CALM_DOWN_VGS]: {
    id: PageIdWoofzVgs.CALM_DOWN_VGS,
    theme: THEMES.VARIANT_VGS,
    hasHeaderBackButton: true,
    progressBar: 'controlled',
    hasHeader: true,
  },
  [PageIdWoofzVgs.URGE_4_VGS]: {
    id: PageIdWoofzVgs.URGE_4_VGS,
    theme: THEMES.URGE,
    hasHeader: true,
    hasHeaderBackButton: true,
  },
  [PageIdWoofzVgs.URGE_TOUCH]: {
    id: PageIdWoofzVgs.URGE_TOUCH,
    theme: THEMES.URGE,
    hasHeader: true,
    hasHeaderBackButton: true,
  },
  [PageIdWoofzVgs.DOG_REACT_VGS]: {
    id: PageIdWoofzVgs.DOG_REACT_VGS,
    theme: THEMES.VARIANT_VGS,
    hasHeaderBackButton: true,
    progressBar: 'controlled',
    hasHeader: true,
  },
  [PageIdWoofzVgs.STRESSFUL_WALKS_VGS]: {
    id: PageIdWoofzVgs.STRESSFUL_WALKS_VGS,
    theme: THEMES.VARIANT_VGS,
    hasHeaderBackButton: true,
    progressBar: 'controlled',
    hasHeader: true,
  },
  [PageIdWoofzVgs.URGE_3_VGS]: {
    id: PageIdWoofzVgs.URGE_3_VGS,
    theme: THEMES.URGE,
    progressBar: 'controlled',
    hasHeader: true,
  },
  [PageIdWoofzVgs.DOG_ACT_VGS]: {
    id: PageIdWoofzVgs.DOG_ACT_VGS,
    theme: THEMES.VARIANT_VGS,
    hasHeaderBackButton: true,
    progressBar: 'controlled',
    hasHeader: true,
  },
  [PageIdWoofzVgs.DOG_OFF_AT_HOME_VGS]: {
    id: PageIdWoofzVgs.DOG_OFF_AT_HOME_VGS,
    theme: THEMES.VARIANT_VGS,
    hasHeaderBackButton: true,
    progressBar: 'controlled',
    hasHeader: true,
  },
  [PageIdWoofzVgs.AGGRESSIVE_VGS]: {
    id: PageIdWoofzVgs.AGGRESSIVE_VGS,
    theme: THEMES.VARIANT_VGS,
    hasHeaderBackButton: true,
    progressBar: 'controlled',
    hasHeader: true,
  },
  [PageIdWoofzVgs.DOG_IGNORED_VGS]: {
    id: PageIdWoofzVgs.DOG_IGNORED_VGS,
    theme: THEMES.VARIANT_VGS,
    hasHeaderBackButton: true,
    progressBar: 'controlled',
    hasHeader: true,
  },
  [PageIdWoofzVgs.LOADER_SCREEN_VGS]: {
    id: PageIdWoofzVgs.LOADER_SCREEN_VGS,
  },
  [PageIdWoofzVgs.DOG_STATISTICS_VGS]: {
    id: PageIdWoofzVgs.DOG_STATISTICS_VGS,
    hasHeaderBackButton: true,
    theme: THEMES.VARIANT_VGS,
    hasHeader: true,
  },
  [PageIdWoofzVgs.TIME_VGS]: {
    id: PageIdWoofzVgs.TIME_VGS,
    hasHeaderBackButton: true,
    theme: THEMES.VARIANT_VGS,
    hasHeader: true,
    progressBar: 'controlled',
  },
  [PageIdWoofzVgs.URGE_5_VGS]: {
    id: PageIdWoofzVgs.URGE_5_VGS,
    hasHeaderBackButton: true,
    theme: THEMES.URGE,
    hasHeader: true,
  },
  [PageIdWoofzVgs.PREPARE_FLOW_VGS]: {
    id: PageIdWoofzVgs.PREPARE_FLOW_VGS,
    theme: THEMES.VARIANT_VGS,
    hasHeader: true,
    hasHeaderBackButton: true,
  },
  [PageIdWoofzVgs.EMAIL_VGS]: {
    id: PageIdWoofzVgs.EMAIL_VGS,
    theme: THEMES.VARIANT_VGS,
    hasHeader: true,
    hasHeaderBackButton: true,
  },
  [PageIdWoofzVgs.NEWSLETTER_VGS]: {
    id: PageIdWoofzVgs.NEWSLETTER_VGS,
    hasHeaderBackButton: true,
    theme: THEMES.VARIANT_VGS,
    hasHeader: true,
  },
  [PageIdWoofzVgs.PERSONALIZED_PLAN_VGS]: {
    id: PageIdWoofzVgs.PERSONALIZED_PLAN_VGS,
    theme: THEMES.VARIANT_VGS,
    hasHeader: true,
  },
  [PageIdWoofzVgs.LAST_CHANCE_OFFER_VGS]: {
    id: PageIdWoofzVgs.LAST_CHANCE_OFFER_VGS,
    theme: THEMES.VARIANT_VGS,
    hasHeader: true,
  },
  [PageIdWoofzVgs.SUBSCRIPTIONS_VGS]: {
    id: PageIdWoofzVgs.SUBSCRIPTIONS_VGS,
  },
  [PageIdWoofzVgs.UPSELL_VGS]: {
    id: PageIdWoofzVgs.UPSELL_VGS,
    hasHeader: true,
    theme: THEMES.POLICY,
  },
  [PageIdWoofzVgs.CHAT_UPSELL_VGS]: {
    id: PageIdWoofzVgs.CHAT_UPSELL_VGS,
    hasHeader: true,
    theme: THEMES.POLICY,
  },
  [PageIdWoofzVgs.DOWNLOAD_VGS]: {
    id: PageIdWoofzVgs.DOWNLOAD_VGS,
    hasHeader: true,
    theme: THEMES.POLICY,
  },
}
